import { ReportField, ReportFieldType } from '../../../models/reportField';
import { RuleBuilderInput, RuleBuilderInputValue } from '../rule-builder';
import { validate } from '../../../util';
import { ReportIncludedFieldFilterOperator } from '../../../models';

const validateValue = (
  field: ReportField,
  value: RuleBuilderInputValue,
): string => {
  const errorMsg = 'Must use valid field content';
  switch (field.fieldType) {
    case ReportFieldType.Text:
      return validate(value as string, { presence: errorMsg });
    case ReportFieldType.Number:
      return validate(value as string, {
        presence: errorMsg,
        number: errorMsg,
      });
    case ReportFieldType.Date:
      return validate(value as string, {
        presence: errorMsg,
        fullDate: errorMsg,
      });
    case ReportFieldType.DropDown:
      return !value || !value.length ? errorMsg : '';
  }
  return '';
};

const validateRulebuilderInput = (
  field: ReportField,
  rule: RuleBuilderInput,
): RuleBuilderInput => {
  const nextRule = { ...rule, value1Err: '', value2Err: '' };
  nextRule.value1Err = validateValue(field, rule.value1);
  if (rule.comparisonRule === ReportIncludedFieldFilterOperator.between) {
    nextRule.value2Err = validateValue(field, rule.value2);
  }
  return nextRule;
};

export default validateRulebuilderInput;
